import { SvgIconProps } from '@traba/types'

export default function PhoneFilled({
  color = '#7A8A99',
  size = 24,
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.77053 7.5C7.06884 7.5 6.5 8.01563 6.5 8.6517C6.5 8.79594 6.52198 8.93949 6.56532 9.07827L6.60701 9.2118C6.80356 9.84128 7.37421 10.3169 8.08266 10.4417C8.52343 10.5194 8.97657 10.5194 9.41734 10.4417C10.1258 10.3169 10.6964 9.84128 10.893 9.2118L10.9347 9.07827C10.978 8.93949 11 8.79594 11 8.6517C11 8.01563 10.4312 7.5 9.72947 7.5H7.77053Z"
        fill={color}
      />
      <path
        d="M5 2.77053C5 2.06884 4.48437 1.5 3.8483 1.5C3.70406 1.5 3.56051 1.52198 3.42173 1.56532L3.2882 1.60701C2.65872 1.80356 2.18309 2.37421 2.05825 3.08266C1.98058 3.52343 1.98058 3.97657 2.05825 4.41734C2.18309 5.12579 2.65872 5.69644 3.2882 5.89299L3.42173 5.93468C3.56051 5.97802 3.70406 6 3.8483 6C4.48437 6 5 5.43116 5 4.72947L5 2.77053Z"
        fill={color}
      />
      <path
        d="M8.08266 10.4417C8.52343 10.5194 8.97657 10.5194 9.41734 10.4417C10.1258 10.3169 10.6964 9.84128 10.893 9.2118L10.9347 9.07827C10.978 8.93949 11 8.79594 11 8.6517C11 8.01563 10.4312 7.5 9.72947 7.5H7.77053C7.06884 7.5 6.5 8.01563 6.5 8.6517C6.5 8.79594 6.52198 8.93949 6.56532 9.07827L6.60701 9.2118C6.80356 9.84128 7.37421 10.3169 8.08266 10.4417ZM8.08266 10.4417C5.02098 9.87446 2.62554 7.47902 2.05825 4.41734M2.05825 4.41734C1.98058 3.97657 1.98058 3.52343 2.05825 3.08266C2.18309 2.37421 2.65872 1.80356 3.2882 1.60701L3.42173 1.56532C3.56051 1.52198 3.70406 1.5 3.8483 1.5C4.48437 1.5 5 2.06884 5 2.77053L5 4.72947C5 5.43116 4.48437 6 3.8483 6C3.70406 6 3.56051 5.97802 3.42173 5.93468L3.2882 5.89299C2.65872 5.69644 2.18309 5.12579 2.05825 4.41734Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  )
}
